import {setupLiveToggle, isLive} from './liveToggle'
import debouncedRefresh from './debouncedRefresh'
import managedSubscription from './managedSubscription'

const subscription = managedSubscription()
const fastRefresh = debouncedRefresh(1000)
const slowRefresh = debouncedRefresh(5000)

$(document).on('turbo:load', function() {
  const config = $('#cable')?.data() || {}

  if (config.channel != 'DevicesChannel') {
    subscription.clear()
    return
  }

  const {channel, deviceId, updates} = config

  setupLiveToggle(channel)

  subscription.ensure(config, {channel: channel, deviceId: deviceId}, {
    received(data) {
      if (updates.includes(data.update)) {
        switch(data.update) {
          case 'new-check-ins':
            if (isLive(channel)) {
              fastRefresh.next()
            }
            break
          case 'new-status-logs':
            if (isLive(channel)) {
              slowRefresh.next()
            }
            break
          default:
            throw `Unmatched update on ${channel}: ${data}`
        }
      }
    }
  })
})
